import { ApolloError } from '@apollo/client';
import { TFunction } from 'i18next';
import { bpErrorsCodes } from 'activate-errors';

function isApolloError(error: unknown): error is ApolloError {
  return typeof error === 'object' && error !== null && 'graphQLErrors' in error;
}

function hasErrorCode(exception: unknown): exception is { code: string } {
  return typeof exception === 'object' && exception !== null && 'code' in exception;
}

export const createCategoryErrorMessage = (
  error: ApolloError | Error | unknown,
  t: TFunction
): string => {
  const defaultMessage = t('abp.productsServices.createCategory.error');

  if (isApolloError(error)) {
    const firstGraphQLError = error.graphQLErrors?.[0];
    
    const exception = firstGraphQLError?.extensions?.exception;
    const errorCode = hasErrorCode(exception) ? exception.code : null;
    
    if (errorCode === bpErrorsCodes.productCategoryAlreadyExistsError.code) {
      return t('abp.productsServices.editCategory.nameAlreadyExists');
    }

    return firstGraphQLError?.message || defaultMessage;
  }

  return defaultMessage;
};